import Debug from "debug";
const debug = Debug("ot-whiteboard:transform");

let transforms = {};

const opKey = (op) => {
  if (op.hasOwnProperty("co")) {
    return "create_object";
  } else if (op.hasOwnProperty("do")) {
    return "delete_object";
  } else if (op.hasOwnProperty("cp")) {
    return "update_property";
  } else if (op.hasOwnProperty("cs")) {
    return "stack_create";
  } else if (op.hasOwnProperty("ds")) {
    return "stack_delete";
  } else if (op.hasOwnProperty("us")) {
    return "stack_update";
  } else {
    console.warn(`Unknown operation type: ${JSON.stringify(op)}`);
  }
};

const transformKey = (type1, type2) => `${type1}-${type2}`;

// Define the transform that updates an operation of type1 so that it can be
// run after an operation of type2.
//
// The transform function should be of the form:
//   (op1, op2, side) => transformedOp1
//
// For the "left" side then op1 should override op2. For the "right"
// side then op2 should override op1 (usually by doing nothing).
const defineTransform = (type1, type2, transform) => {
  if (transforms[transformKey(type1, type2)]) {
    console.warn(`Already defined a transform for ${type1}, ${type2}`);
  }
  transforms[transformKey(type1, type2)] = transform;
};

const transform = (op1, op2, side) => {
  const transformFunction = transforms[transformKey(opKey(op1), opKey(op2))];
  if (transformFunction) {
    if (debug.enabled) {
      debug(`transforming (${side}) ${JSON.stringify(op1)}`);
      debug(`  against previous ${JSON.stringify(op2)}`);
    }

    const tOp = transformFunction(op1, op2, side);

    if (debug.enabled) {
      debug(`  became  ${JSON.stringify(tOp)}`);
    }

    return tOp;
  } else {
    console.warn(`Unhandled transform: "${opKey(op1)}", "${opKey(op2)}"`);
    return op1;
  }
};

export { defineTransform, transform };
